import { createFileRoute } from "@tanstack/react-router";

import { KycOnboarding } from "@/components/kyc/KycOnboarding";
import { requireOnboarding } from "@/lib/require-auth";

export const Route = createFileRoute("/onboarding")({
  beforeLoad: () => {
    requireOnboarding();
  },
  component: KycOnboarding,
});
